module.exports = __webpack_public_path__ + "banquet/components/Navbar/images/nav_heart_selected.908aca195e58bc269a2d157284dcafe8.svg";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/Navbar/images/nav_heart_selected.svg
// module id = 1683
// module chunks = 1